import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Grid, Button, Typography } from "@material-ui/core"
import { useHistory, useLocation } from "react-router-dom"
import { Skeleton } from "@material-ui/lab"
import BackArrowSvg from "../icons/BackArrowSvg"
import { getRetainFiltersSuccess } from "../../actions/infoActions"
import { LAST_OPENED_FILE_ID } from "../../utils"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		marginBottom: "20px",
		padding: "6px 23px",
		"& .MuiButton-contained:hover": {
			backgroundColor: "#0d87e9",
			boxShadow: theme.shadows[3],
		},
	},
	backButton: {
		...theme.typography.button,
		textTransform: "math-auto",
		backgroundColor: theme.palette.primary.dark,
	},
}))

const ViewerBackButtonBox = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const location = useLocation()
	const history = useHistory()
	const theme = useTheme()
	const [t] = useTranslation("global")
	const [toClearRetainedFilterData, setToClearRetainedFilterData] = useState(false)

	const handleBack = () => {
		const path = location?.pathname?.split("/")
		path?.[3] && localStorage?.setItem(LAST_OPENED_FILE_ID, path?.[3])
		history.push(`${path?.[0]}/${path?.[1]}${window.location.search}`)
	}

	return (
		<Grid container className={classes.root}>
			{props?.loading ? (
				<Skeleton variant="rect" width="100%" style={{ margin: "5px", padding: "18px 10px" }}></Skeleton>
			) : (
				<>
					<Grid item xs={12} sm={3} style={{ visibility: "hidden", display: "flex", flex: "1" }}>
						<Typography variant="body1">{props?.prevPage}</Typography>
					</Grid>
					<Grid
						item
						xs={12}
						sm={9}
						style={{ justifyContent: "flex-end", alignItems: "center", display: "flex", marginRight: "10px", flex: "1" }}
					>
						<Button size="small" variant="contained" className={classes.backButton} onClick={handleBack}>
							<BackArrowSvg style={{ marginRight: "5px" }} />
							{t("viewer.back")}
						</Button>
					</Grid>
				</>
			)}
		</Grid>
	)
}

export default ViewerBackButtonBox
